function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}


function removeTrapFocus(elementToFocus = null) { 
  /*commented above code menu close issue*/
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown); 

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// class QuantityInput extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input');
//     this.changeEvent = new Event('change', { bubbles: true })

//     this.querySelectorAll('button').forEach(
//       (button) => button.addEventListener('click', this.onButtonClick.bind(this))
//     );
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const previousValue = this.input.value;
// console.log(event.target.name);
//     event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
//     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
//   }
// }

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.minusButton = this.querySelector('button[name="minus"]');
    this.plusButton = this.querySelector('button[name="plus"]');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.updateButtonState(); // Initial check
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = parseInt(this.input.value);

    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else if (event.target.name === 'minus') {
      this.input.stepDown();
    }

    const newValue = parseInt(this.input.value);
    if (previousValue !== newValue) {
      this.input.dispatchEvent(this.changeEvent);
    }

    this.updateButtonState();
  }

  updateButtonState() {
    const value = parseInt(this.input.value);
    const min = parseInt(this.input.min) || 1;
    const max = parseInt(this.input.max) || Infinity;

    this.minusButton.disabled = value <= min;
    this.plusButton.disabled = value >= max;
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

$(document).keyup(function (e) {
    if (e.key === "Escape") {
        $(".includespopup .popup-close .close, .whats-included-popup .popup-close .close").trigger("click");
        if($('.modal.fade').hasClass('show')){$('.modal.fade button.close').trigger("click");}
    }
});

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    //this.header = this.header || document.getElementById('shopify-section-brand-header') || document.getElementById('shopify-section-lp-header');
    this.header = summaryElement.closest('.brand-header');

    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button)
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

function getPurchaseOptSelectedValue(name) {
  const radios = document.getElementsByName(name); // Get all radio buttons by name
  for (const radio of radios) {
    if (radio.checked) {
      return radio.value; // Return the value of the selected radio button
    }
  }
  return null; // Return null if no radio button is selected
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    /*
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    */
    if (this.prevButton) {
  if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
    this.prevButton.setAttribute('disabled', 'disabled');
  } else {
    this.prevButton.removeAttribute('disabled');
  }
}  

 if (this.nextButton) {
  if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
    this.nextButton.setAttribute('disabled', 'disabled');
  } else {
    this.nextButton.removeAttribute('disabled');
  }
} 
    
    /*
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    } */
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable(); 
    } else {
      this.updateMedia();
      if(typeof this.dataset.shop === 'undefined' && this.dataset.shop === null) {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
       
      }else{
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);  
        const productForm_button =productForm.querySelector('button[name="add"]'); 
        const seling_plan = productForm.querySelector('[name="selling_plan"]');
        const selectedValue = getPurchaseOptSelectedValue('purchaseOption');

        this.shop_qty_limit_btn_click()
        window.variantStrings.addToCart="Subscribe";        
        if(seling_plan == null || selectedValue=='onetime'){
         window.variantStrings.addToCart="Add to Cart"; 
        }
        
         this.updateVariantInput();
        this.renderProductInfoForShop();
      }
      this.updateShareUrl();
    }
  }

  shop_qty_limit_btn_click() {
    try {
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
                const items = data.items;
                var filteredItems = items.filter(function(item) {
                    return typeof item.selling_plan_allocation?.selling_plan.id === "number";
                });
                filteredItems.forEach(item => {
                    var cart_item_qty = parseInt(item.quantity);
                    var cart_variant_id = parseInt(item.id);
                    var variant_id = parseInt($("#subscribe-" + item.product_id).find('[name="id"]').val(), 10);

                    if (cart_variant_id === variant_id) {
                       if (cart_item_qty <= 3) {
                            $("#subscribe-" + item.product_id).find(".addto-cart-button-subscribe").prop('disabled', false);
                            $(".shop-qty-error").remove();
                            if ($("#subscribe-" + item.product_id).find(".ingpopup .shop-qty-error").length > 0) {
                              $("#subscribe-" + item.product_id).find(".ingpopup .shop-qty-error").remove();
                            }
                        }
                    }
                });
            });
    } catch (e) {
        console.error(e);
    }
}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    /*mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)); */
    mediaGalleries.forEach(mediaGallery => {
  if (typeof mediaGallery.setActiveMedia === 'function') {
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
  } 
});

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    const is_shop_page = document.querySelector(`.is_shop_page`);

    const variant_url = document.querySelectorAll(`.product-link-${this.dataset.productid}`);
    variant_url.forEach(element => {
        element.setAttribute('href', this.dataset.url + '?variant=' + this.currentVariant.id);
    });
   const product_urls = document.getElementsByClassName("popup-product-"+this.dataset.productid);
if (product_urls.length > 0) {
  for (let i = 0; i < product_urls.length; i++) {
    product_urls[i].classList.add("hide");
  }
}

const variant_prices = document.getElementsByClassName("popup-variant-price-"+this.currentVariant.id);
if (variant_prices.length > 0) {
    variant_prices[0].classList.remove("hide");
}
   
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || is_shop_page) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

      fetch(`${this.dataset.url}.json`)
      .then((response) => response.json() )
      .then((responseJson) => {
          const variant = responseJson.product.variants.find(v => v.id === this.currentVariant.id);
          const price = variant ? variant.price : null;
          const priceElement = document.getElementById("rc-onetime-price");          
          if (priceElement) {
          priceElement.innerText = "$" + price;
          }
         // document.getElementById("rc-onetime-price").innerText = "$"+price;
      });

  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() { 
  
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, 
       #product-form-installment-${this.dataset.section},  
       #ProductInfo-${this.dataset.section}`
    );
   
  
    productForms.forEach((productForm) => {
      // Update the input value with the current variant ID
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
  
      // Handle qty-error removal
      try {
        const qtyError = productForm.querySelector('.qty-error');
        if (qtyError) {
          qtyError.remove();
        }
      } catch (error) {
        console.log('Error removing qty-error:', error);
      }
  
      // Handle shop-qty-error removal in the closest .ingpopup
      try {
        const ingpopup = productForm.closest('.ingpopup');
        if (ingpopup) {
          const shopqtyErrors = ingpopup.querySelectorAll('.shop-qty-error');
          shopqtyErrors.forEach((shopqtyError) => {
            shopqtyError.remove();
          });
        }
      } catch (error) {
        console.log('Error removing shop-qty-errors:', error);
      }
    });
  }
  

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      if(pickUpAvailability) { pickUpAvailability.fetchAvailability(this.currentVariant.id); }
    } else {
      if(pickUpAvailability) {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
    }
  }

 /* removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
  */
  removeErrorMessage() {
  const section = this.closest('section');
  if (!section) return;

  const productForm = section.querySelector('.product-form');  
  if (productForm && typeof productForm.handleErrorMessage === 'function') {
    productForm.handleErrorMessage();
  }
}

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`); 
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut); 
       
      });   
  }

   renderProductInfoForShop() {
    fetch(`${this.dataset.url}?&variant=${this.currentVariant.id}&section=main-product`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  addToCartLabelText() { 
     var productTitle = document.querySelector('a.product__title');
    var productHandles = ['age-defying-body-face-kit', '2-step-body-kit'];  
    
    if (productTitle && productHandles.includes(productTitle.dataset.handle)) {
        var addToCartLabel = document.querySelector('.add_to_cart_label');
        
        if (addToCartLabel) {
            addToCartLabel.innerHTML = 'Add to Cart';
        }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const seling_plan = productForm.querySelector('[name="selling_plan"]')
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      this.addToCartLabelText();
    } else {
      addButton.removeAttribute('disabled');
      if(seling_plan && seling_plan.value != ""){
        addButtonText.textContent = "Subscribe";        
        
       this.addToCartLabelText();
        
      }else{
        if(addButtonText){
        addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


//Subscription section Recharge app flow modiifed //


function rcWidjectCustomize(){    
 
  setTimeout(function(){

   
    var oneTime = $('.onetime-radio .rc-radio__label').text();
    var splitedPrice = oneTime.split("$");
    var finalPrice = splitedPrice.pop();  
  
    $('.recharge-subscription-widget').css('display','block');
  
    var originalPrice = $('.product__info-wrapper .price__container .price__sale s.price-item--regular').text().trim();
   //var originalPrice = $('.price-item.price-item--regular.button-price-label').text().trim();

    // Remove any non-numeric characters and whitespace
    var cleanedPrice = originalPrice.replace(/[^0-9.]/g, '');    
    var formattedPrice = "$" + parseFloat(cleanedPrice).toFixed(2); 
    
    if($('.price-section .offer-price-block').length > 0){
      var offerPercentage = $('.offer-price-block .offer-percentage').text();     
      splitedPrice = splitedPrice + ': <b>SAVE '+offerPercentage+'%</b>';
      var originalPrice = $('.offer-price-block .original-price-item').text();
      var originalPriceValue = originalPrice.replace(/[^0-9.]/g, '');
      var orginalPriceOneTime = "$" + parseFloat(originalPriceValue).toFixed(2); 
      var offerPrice = $('.offer-price-block .offer-price-item').text();    
      
      finalPrice = '<s>'+orginalPriceOneTime+'</s><span class="offer-price">'+offerPrice+'</span>';
      var combinedContent = 'One-Time Purchase ' + splitedPrice;
      var stickyfooterstrikeprice = "";
      if( originalPrice != ''){ stickyfooterstrikeprice = '<s>'+formattedPrice+'</s>'; }
      $('.pdp-sticky-footer .sticky-footer-price').html(stickyfooterstrikeprice + $('.subscription-radio .rc-radio__price').text());
      
    }else{ finalPrice = '$'+ finalPrice;
          var stickyfooterstrikeprice = "";
          if( originalPrice != ''){ stickyfooterstrikeprice = '<s>'+formattedPrice+'</s>'; }
            var subcription_activeRadio = $('.rc-widget .subscription-radio').length;
            var onetime_activeRadio = $('.rc-widget .onetime-radio').length;
            if ((subcription_activeRadio > 0) && (onetime_activeRadio > 0)){ 
              $('.pdp-sticky-footer .sticky-footer-price').html('<span class="pdp-price-span no-compare-price">'+$('.rc-radio--active.subscription-radio .rc-radio__price').html()+'</span>');
               
            }else{
             //  $('.pdp-sticky-footer .sticky-footer-price').html($(".product__info-container .price-container").clone().find('.menbership').remove().end()); 
               $('.pdp-sticky-footer .sticky-footer-price').html($(".price__container .price__sale").html());  
            }
 
    }    

    

    $(".onetime-radio").insertAfter("div.rc-template__radio"); 
    $('.onetime-radio .rc-radio__label').clone().insertAfter('.onetime-radio span.rc-radio__label').html(splitedPrice);
    $('.custom-onetime-radio .onetime-radio-label').html(combinedContent);
    $('.onetime-radio span.rc-radio__label:nth-child(2)').attr('id','rc-onetime-price').html(finalPrice);
    $('.rc-selling-plans').insertAfter('.subscription-radio .rc-radio__label');
    $('.save-and-subscribe-pdp').insertAfter('.subscription-radio .rc-radio__label'); 
   if( originalPrice != ''){     
     $('.subscription-radio .rc-radio__price').html('<s>'+formattedPrice+'</s>'+$('.subscription-radio .rc-radio__price').text());  
   }
      
    $('.shipping-frequency-section').clone().insertAfter('.rc-selling-plans .rc-selling-plans-single, .rc-selling-plans .rc-selling-plans-dropdown .rc-selling-plans-dropdown__select');
    $('.technology-section').insertAfter('#benefits');        
    $('.rc-widget .save-and-subscribe-pdp').css('display','flex');
    if($('[name="purchaseOption"]').val()=="subscription"){
      $(".product-form__buttons").find(".product-form__submit > span").text("Subscribe");
      // $(".product-form__buttons .button-price-label").html($('.subscription-radio .rc-radio__price').text());
      let subscription_price = $('.subscription-radio .rc-radio__price').html();
      $('.product-form-add-to-cart .btn-price .price--large .price__sale .price-item.price-item--sale').html(subscription_price);
    }

    $('.sticky-header-btn-label').html($('.add_to_cart_label').html());
   //updateRadioLabelClasses();
    
   
    if($('.recharge-subscription-widget .rc-widget').length == 0){
      function formattedPriceFinal(selector, prefix) {
        var priceText = $(selector).text();
        var priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        var FianlFormattedPrice = prefix + priceValue.toFixed(2);
        return FianlFormattedPrice;
      }        
      var offOneTimePriceFinal = formattedPriceFinal('.offer-price-block .offer-price-item', '$');
      var offOneTimePriceSticky = formattedPriceFinal('.offer-price-block s.original-price-item', '$');
      var CustomFormattedPrice = formattedPriceFinal('.product__info-wrapper .price-section .price__container .price__sale .price-item', '$');
      
      if($('.offer-price-block').length > 0){
        $('.custom-onetime-radio .price-label').html('<s>'+ offOneTimePriceSticky +'</s>'+offOneTimePriceFinal);
        $('.pdp-sticky-footer .sticky-footer-price').html('<s>'+offOneTimePriceSticky+'</s>'+ offOneTimePriceFinal);
      }else{
        $('.custom-onetime-radio .price-label').html('<s>'+ $('.product__info-wrapper .price__container .price-section s.price-item--regular').text() +'</s>'+CustomFormattedPrice);
        //$('.custom-onetime-radio .price-label').html('<s>'+ $('.product__info-wrapper .price__container .price-section s.price-item--regular').text() +'</s>'+$('.product__info-wrapper .price-section .price__container .price__sale .price-item').text());
          $('.pdp-sticky-footer .sticky-footer-price').html('<s>'+ $('.product__info-wrapper .price__container .price-section s.price-item--regular').text()+'</s>'+CustomFormattedPrice);
      }
      $('.custom-rc-widget').removeClass('hide');      
    }
  
    if ($('.custom-pdp-label').hasClass('membership-radio')) { 
      // $('.pdp-subcription-products input[type="radio"]').prop('checked', true).click();
      // $('input[type="radio"][value="subscription"]').prop('checked', true).click();
       $('.rc-widget label').removeClass('rc-radio--active'); 
      //updateRadioLabelClasses();
    }


    
 var default_selected_radio = document.querySelector('.default_selected_value');
if (default_selected_radio) {
  var  default_selected_value = default_selected_radio.value;
if (default_selected_value !== '') {
    var radioButtonValue = '';

    // Map default value to radio button value
    if (default_selected_value === 'upsell_product') {
        radioButtonValue = 'membership';
    } else if (default_selected_value === 'onetime') {
        radioButtonValue = 'onetime';
    } else if (default_selected_value === 'subscription') {
        radioButtonValue = 'subscription';
    }

    var radioBtn = document.querySelector('input[type="radio"][value="' + radioButtonValue + '"]');
    if (radioBtn) {
        // Get radio button's ID and clear all active classes from labels
        var radioBtnId = radioBtn.id;

        document.querySelectorAll('label').forEach(function (label) {
            label.classList.remove('rc-radio--active', 'ce-rc-active');
        });

        // Check the radio button and trigger change event
        radioBtn.checked = true;
        radioBtn.dispatchEvent(new Event('change', { bubbles: true }));
        radioBtn.dispatchEvent(new Event('click', { bubbles: true }));

        // Add active classes to the associated label
        var label = radioBtn.closest('label') || document.querySelector('label[for="' + radioBtnId + '"]');
        if (label) { 
            label.classList.add('rc-radio--active', 'ce-rc-active');
            label.dispatchEvent(new Event('click', { bubbles: true }));
        }

        // Trigger change event on the active label
        var activeLabel = document.querySelector('.rc-radio--active');
        if (activeLabel) {  label.classList.add('rc-radio--active', 'ce-rc-active');
            activeLabel.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
  // updateRadioLabelClasses();
}
} 
  },2500);  
   // setTimeout(function(){ 
   //  updateRadioLabelClasses();  
   // },3000);  
  
   // setTimeout(function(){ 
   //   $('.pdp-sticky-footer .sticky-footer-price').html('<span class="pdp-price-span no-compare-price">'+$('.rc-radio--active.subscription-radio .rc-radio__price').html()+'</span>');
   // },3000);  
}  

function updatePurchaseOptionLabel() {
  $('label').removeClass('ce-rc-active'); 

  const selectedValue = $('input[name="purchaseOption"]:checked').val();
  $('.button-price-label').html(selectedValue); // default fallback

  if (selectedValue === 'subscription') {
    $('.button-price-label').html($('.subscription-radio .rc-radio__price').html());
  }

  if (selectedValue === 'onetime') {
    $('.button-price-label').html($('#rc-onetime-price').html());
  }
   
}

// On change
$(document).on('change', 'input[name="purchaseOption"]', function() {
  updatePurchaseOptionLabel();
});

// On load
$(document).ready(function() {
//  setTimeout(updatePurchaseOptionLabel, 2800); // slight delay in case Recharge updates the DOM
});



function updateRadioLabelClasses() {   
    $('label').removeClass('ce-rc-active');   
   
    $('input[name="purchaseOption"]').each(function() {  
        if ($(this).is(':checked')) {  
            if ($(this).closest('label').length) {
                $(this).closest('label').addClass('ce-rc-active');
            } else {
                var id = $(this).attr('id'); 
                $('label[for="' + id + '"]').addClass('ce-rc-active');
            }             
            return false; 
        }
    }); 
}

$(document).on('change', 'input[name="purchaseOption"]', function() {  
    $('label').removeClass('ce-rc-active'); 
        
    if ($(this).closest('label').length) {
        $(this).closest('label').addClass('ce-rc-active');  
    }     
    else {
        var id = $(this).attr('id'); 
        $('label[for="' + id + '"]').addClass('ce-rc-active');
    }
});
 
$(document).on('click','.quick-add__submit', function(){  
  var productID = $(this).attr("data-productid"); 
  //window.initRecharge;  
  setTimeout(function(){
    rcWidjectCustomize();
    if(productID && $('.rc-widget').length == 0){
      window.ReChargeWidget.createWidget({ productId: productID, injectionParent: '.recharge-subscription-widget' });     
    }
   },2000);  
   setTimeout(function(){
     if($('.rc-widget').length > 0){
      $('.quick-add-modal__content-info').css('visibility','visible');
      $('.save-and-subscribe-pdp').insertAfter('.quick-add-modal .rc-subscription-details');
      $('.quick-add-modal .product__media-list .product__media-item:nth-child(1) .product__media img').trigger('click');
      $('.save-and-subscribe-pdp').insertAfter('.quick-add-modal .subscription-radio .rc-radio__label');
      $('.shipping-frequency-section').insertAfter('.quick-add-modal .subscription-radio .rc-radio__label');
   }
   },3000);   
});

$(document).on('click', '.subscription-radio, .onetime-radio', function () { 
   /*for learn more link click trigger prevent label click*/
  //  if ($(event.target).is('a')) { 
  //       return false;   
  //   } 
  
    setTimeout(function () {    
     if ($('.subscription-radio .shipping-frequency-section').length == 0) {
        var clonedSection = $('.shipping-frequency-section').clone();
        $('.rc-selling-plans .rc-selling-plans-single, .rc-selling-plans .rc-selling-plans-dropdown .rc-selling-plans-dropdown__select').after(clonedSection);
     }      
    }, 500);    
  
  if ($(this).hasClass('onetime-radio')) {
    $('.product-form__quantity').show();
   // $('.product-form__quantity').find('.quantity__button').removeAttr("disabled");
    $('.product-form__quantity').find('.quantity__input').removeAttr("readonly"); 
    // if($('.product-form__quantity').find('.quantity__input').val() != $('.product-form__quantity').find('.quantity__input').attr("max")){
    //   $('.product-form__quantity').find('.quantity__button[name="plus"]').attr("disabled", false);
    //   $('.product-form__quantity').find('.quantity__button[name="minus"]').attr("disabled", true);
    // } 
    // if($('.product-form__quantity').find('.quantity__input').val() == 1){
    //   $('.product-form__quantity').find('.quantity__button[name="plus"]').attr("disabled", true);
    //   $('.product-form__quantity').find('.quantity__button[name="minus"]').attr("disabled", false);
    // }
    
  } else {
    $('.product-form__quantity').hide();
    /*$('.product-form__quantity').find('.quantity__button').addAttr("disabled");
    $('.product-form__quantity').find('.quantity__input').addAttr("readonly");
    */
   
   // $('.product-form__quantity').find('.quantity__button').attr("disabled", true);
    $('.product-form__quantity').find('.quantity__input').attr("readonly", true);    
    // if($('.product-form__quantity').find('.quantity__input').val() != $('.product-form__quantity').find('.quantity__input').attr("max")){
    //   $('.product-form__quantity').find('[name="minus"]').attr("disabled", false);
    // } 
    // if($('.product-form__quantity').find('.quantity__input').val() == 1){
    //   $('.product-form__quantity').find('[name="plus"]').attr("disabled", false);
    // }

  }
});

$(document).on('click','.shipping-frequency-section label', function(){    
    $('.shipping-frequency-section .paymentOpTooltip').toggleClass('active');   
});

//play video button
 $('.tech-video-btn').click(function (){
    $('.video-player-modal').addClass('visible');
    $('body').addClass('no-scroll');
    $('html').css("overflow-y", "hidden");
    var dataVideoURL = $(this).attr('data-videourl');
    $('video#'+dataVideoURL).trigger('load').trigger('play');
});

 $('.tech-video-button').click(function (){
    $('.video-player-modal').addClass('visible');
    $('body').addClass('no-scroll');
    $('html').css("overflow-y", "hidden");
    var dataVideoURL = $(this).attr('data-videourl');
    $('#lp-technology-video').trigger('load').trigger('play');
});
$(document).ready(function(){   
  rcWidjectCustomize(); 
  setTimeout(function(){      
   $('.buy-button').removeClass('hide')
  },3000)
  
    //payment tool tip active
    $(".pdp-page , .pdp-product-section").on('click', function(e) {  
      if (!$(e.target).is('.shipping-frequency-section label')) { 
        $('.shipping-frequency-section .paymentOpTooltip').removeClass('active');
      }
    });

    //pdp-sticky footer button click
    $('.pdp-sticky-footer .btn-checkout').on("click", function(){
      $('.buy-button .addto-cart-button').trigger('click');
   });  

  $('.pdp-sticky-footer .btn-checkout-wrapper').on("click", function(){
    $("html, body").animate({ scrollTop: $(".addto-cart-button").offset().top - 100});
  });

  if($('#lp-technology-video').length>0) {
    var ellenReply = document.getElementById("lp-technology-video");
	var replay = document.getElementById("replayButton");
	$(replay).click(function (){
	$(".replayButton").addClass("hide");
	$(ellenReply).trigger('load').trigger('play');
	});
	function videoEnd() {
		replay.className = "replayButton";
		ellenReply.setAttribute("controls","controls");
		$(".replayButton").show();
	}
	ellenReply.addEventListener("ended", videoEnd, false);
	ellenReply.addEventListener('pause', function () {
		ellenReply.pause();
	}, false);
	ellenReply.addEventListener('play', function () {
	ellenReply.play();
	$(".replayButton").hide();
	}, false);
  }
});
$('.nonvimeo-close-info-modal').click(function() {
	$('.video-player-modal').removeClass('visible');
	$('body').removeClass('no-scroll');
	$('html').css("overflow-y", "visible"); 
	var pauseVideo = $(".non-vimeo-video").attr("id");
	$('video#'+pauseVideo).trigger('pause');
}); 

// Recommendation section carousel start 

$(document).ready(function (){    
  setTimeout (function (){
    if ($("#recommendation-section.product-grid .grid__item").length > 1) {
    if ($("#recommendation-section").hasClass('slick-initialized')) {
  		$("#recommendation-section").slick('unslick');
  	}    
  	$("#recommendation-section").slick({
        dots: false,
		mobileFirst: true,
		autoplay: false,
		autoplaySpeed: 8000,
		arrows: true,
		infinite: true,
		cssEase: 'linear',
		centerMode: true,
		centerPadding: 0,
		speed: 750, 
		slidesToShow: 1,
		responsive: [
        {
  			breakpoint: 640,
  			settings: {
  				slidesToShow: 1,
  				slidesToScroll: 1,
  			}
  		},{
  			breakpoint: 767,
  			settings: {
  				slidesToShow: 3,
  				slidesToScroll: 1,
  			}
  		}]
  	})
  
  }
  }, 3000); 
});


$(document).ready(function (){
  $('.card__inner .card__media').on('mouseenter', function () {
    if ($(window).width() > 1024) {
  		$(this).find(".card-wrapper .card__content .quick-add.no-js-hidden").css({
  			opacity: '1'
  		});
  	}
  });  
}); 

$('.grid-tile .product-image').on('mouseleave', function () {
	$("#quickviewbutton").remove();
	$(this).find(".card-wrapper .card__content .quick-add.no-js-hidden").css({
		opacity : '0'
	});
});
 

setTimeout(function(){ 
  
  if($('.product-included-section .slick-dots li').length > 1 ){
    $('.product-included-section .slick-dots').attr('style', 'display: block !important')
  }; 

},1500);


function pdpReadMore() {
	var readmoreLink=$('<span class="readmore-shortdescription-new"><p>Read More</p></span>');
	$('.product__description').append(readmoreLink);
	$(".product__description").each(function(){
		if($(this).height() < $(this)[0].scrollHeight){
		  $(this).parent().find(".readmore-shortdescription-new").show();
		  $(this).toggleClass("truncate");
		}
	  });
	  $(".readmore-shortdescription-new").click(function(){
        if($(this).parent().hasClass("truncate")) {
				$(this).parent().css("-webkit-line-clamp", 'inherit');
				$(this).children('p').text("Read Less");
			} else {
				$(this).parent().css("-webkit-line-clamp", "3");
				$(this).children('p').text("Read More");
			}
	  	$(this).parent().toggleClass("truncate");	
	  });
}

// $('.save-and-subscribe-slick').not('.slick-initialized').slick({
//     autoplay: true,
//     dots: true,
//     arrows: false,
//     infinite: true,
//     speed: 2000,
//     fade: false,
//     cssEase: 'linear',
//     mobileFirst: true,
//     responsive: [
//         {
//           breakpoint: 640,
//           settings: "unslick"
//         }
//    ]
// }), $(window).on("orientationchange", function() {
//     if($(".save-and-subscribe-slick").hasClass('slick-initialized')){
//         try{
//             $(".save-and-subscribe-slick").slick('unslick');
//         }catch(e){}
//     }
//   });


// Initialize Slick slider only on mobile screens
function initSlickSlider() {
    $('.save-and-subscribe-slick').not('.slick-initialized').slick({
        autoplay: true,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 2000,
        fade: false,
        cssEase: 'linear',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 640,
                settings: "unslick"
            }
        ]
    });
}

// Check if the screen width is less than 640 pixels
function isMobileScreen() {
    return $(window).width() < 640;
}

// Initialize Slick slider on page load if it's a mobile screen
if (isMobileScreen()) {
    initSlickSlider();
}

// Reinitialize Slick slider when the orientation changes or on window resize
$(window).on("orientationchange resize", function () {
    if (isMobileScreen()) {
        initSlickSlider();
    } else {
        try {
            $(".save-and-subscribe-slick").slick('unslick');
        } catch (e) {}
    }
});


$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};  

// sticky footer price update based on the window load
function stickyPriceUpdate() {
    var subcription_activeRadio = $('.rc-widget .subscription-radio').length;
    var onetime_activeRadio = $('.rc-widget .onetime-radio').length; 
    if ((subcription_activeRadio > 0) && (onetime_activeRadio > 0)){
        var newPrice = $('.rc-radio__price').html();
        $('.rc-radio__label:nth-child(1)').html();
        $(".sticky-footer-price .pdp-price-span").html(newPrice);
    } 
}

// sticky footer price update based on the window load
$(window).on('load', function() {
  stickyPriceUpdate();
});

//Sticky header close menu on menuitem click
$('#shopify-section-lp-header a.list-menu__item').on('click', function(){
  $('.menu-drawer-container').removeClass('menu-opening');
  $('summary.header__icon').trigger('click');
});

// sas page loader
$(document).ready(function() {
  setTimeout(function() {
    $(".sas-page-kits-section").show();
    $(".checkout-button").show();
    $(".spinner-icon").hide();   
  }, 100);
});

$(document).ready(function() {
  setTimeout(function() {
    $( ".ce-rc-active" ).trigger( "click" ); 
  }, 3000);
});

// pdp bottom sticky remove empty strike tag when tag has no strike value
function removepriceempty() { 
    $('.sticky-footer-price s').filter(function() {
        return $(this).text().trim() === '';
      }).remove();
}
$(document).ready(function() { 
      setInterval(removepriceempty,1000);	 
});

if(window.location.href.includes('mbglink')){
      $('.grid__item #mbglink details').attr('open', 'open');
      $(".sas-feature-section-block-wrapper a:eq(2)").addClass("active");
}


 /*******pdp navbar start *******/


$(document).ready(function() { 
   setTimeout(function() {
    $('.pdp-nav-section-top .pdp-nav-section').html('');
    $('.target-section').each(function(index) {
        var id = $(this).attr('id');
       var activeClass="";
        if(index==1 && id=='details') {
          $('.pdp-nav-section-top').show();
          $('.pdp-nav-section-top').css('position','inherit'); 
         var activeClass="active";
        }

        var title = $(this).attr('data-section_title');
        if(title!=undefined) { 
            var html = '<a href="#'+id+'" class="pdp-nav-item pdp-link-targets '+activeClass+'">'+title+'</a>';
            $('.pdp-nav-section-top .pdp-nav-section').append(html);
        }

        if(index==1 && id=='details') { 
            $('.pdp-nav-item[href="#' + id + '"]').addClass('active');
        }
    });
      }, 1000);
});

 
 function check_top_nav_items() {
    $('.pdp-nav-section a').each(function() {
        var nav_id = $(this).attr('href');
        var has_id = $(nav_id).length;
        if (has_id == 1) {
            $('a[href="' + nav_id + '"]').show();
        } else {
            $('a[href="' + nav_id + '"]').hide();
        }
    });
}

function handleScroll(click) {  
  if(click==0) {  
    if($('.pdp-nav-section-top').length>0){
         var $stickyNav = $('.pdp-nav-section-top');
            var $stopSticky = $('.pdp-page');
            var stopStickyOffset = $stopSticky.offset().top;
            var scrollPos = $(document).scrollTop();
        
             $('.target-section').each(function() {
                var top = $(this).offset().top-stopStickyOffset;     
                var bottom = top + $(this).outerHeight();
                if (scrollPos >= top && scrollPos <= bottom) {
                  
                    if ($(this).hasClass('pdp-page')) {
                        $stickyNav.removeClass('fixed-sticky');
                    } else {
                        $stickyNav.addClass('fixed-sticky');
                    }
        
                    var activeId = $(this).attr('id');
                var mainString = 'MainProduct-template--16576290259096__main';
        
                 if(mainString.includes(activeId)) {
                     activeId = 'details';
                 }
        
                    $('.pdp-nav-item').removeClass('active');
                    $('.pdp-nav-item[href="#' + activeId + '"]').addClass('active');
                }
            });
      }
      
    }
 
}

$(document).ready(function() {
    check_top_nav_items();
    handleScroll(click=0);


  $(document).on('click', '.pdp-nav-section a', function() {
        var nav_id = $(this).attr('href');
        var offsetIncrease = -1;
        var stickyDivHeight = $('.pdp-nav-section').outerHeight();  
        var targetOffset = $(nav_id).offset().top - offsetIncrease - stickyDivHeight; 
 
         $('html, body').animate({
            scrollTop: targetOffset
        }, 500, function() {
             check_top_nav_items();
        });

        $('.pdp-nav-item').removeClass('active');
        $('.pdp-nav-item[href="' + nav_id + '"]').addClass('active');

       handleScroll(click=1);
    });

    $(window).scroll(function() {
        handleScroll(click=0); 
    });

    setTimeout(function() {
        check_top_nav_items();
    }, 1000);

});
 /*******pdp navbar end *******/


window.onload = function () {
  const desktopIframes = document.querySelectorAll('.resl-result-video-desktop');
  const mobileIframes = document.querySelectorAll('.resl-result-video-mobile');
  let players = [];
  let currentIndex = 0;
  let isInitialized = false;    
  const isMobile = window.innerWidth < 640;
  const targetIframes = isMobile ? mobileIframes : desktopIframes; 
  if (targetIframes.length === 0) return;   
  targetIframes.forEach((iframe, index) => {   
    players[index] = new Vimeo.Player(iframe);     
    players[index].on('ended', function (num) {       
      if (!isInitialized) return;        
      players[index].setCurrentTime(0); 
      currentIndex = (index + 1) % players.length;      
      let nextButton = document.querySelector('.video-btn-section')?.children[currentIndex];       
     if (nextButton) nextButton.click();
     players[currentIndex].play();
    });
  });
  
  Promise.all(players.map(player => player.getDuration()))
    .then(() => {   
      isInitialized = true;        
    })
    .catch(error => console.error('Error initializing players:', error));  
   document.querySelectorAll(".playlists").forEach((playlist, playlistIndex) => {
    playlist.removeEventListener("click", handlePlaylistClick);
    playlist.addEventListener("click", handlePlaylistClick.bind(null, playlistIndex));
  });

  function handlePlaylistClick(playlistIndex) {
    if (window.isVideoPlaying) return;
    window.isVideoPlaying = true;
    setTimeout(() => {
      window.isVideoPlaying = false;
    }, 500);     
    players.forEach(player => player.pause()); 
    currentIndex = playlistIndex;
    players[currentIndex].setCurrentTime(0).then(() => {
      players[currentIndex].play();
    });       
    let nextButton = document.querySelector('.video-btn-section')?.children[currentIndex];
    if (nextButton) nextButton.click();
  }
};


$('.grid.product-grid .variant-image').on('click', function() {
  var productId = $(this).data('product_id'); 
  var newImageSrc = $(this).data('variant-image');
  var allData = $(this).data();
  if(productId>0) {
    $('.grid.product-grid .variant-image').removeClass('selected');
    var variantTitle = $(this).data('variant-title');  
    $(this).addClass('selected');  
    $('.product-link-' + productId + ' .card-product-image').attr('src', newImageSrc);
    $('.product-link-' + productId + ' .card-product-image').attr('srcset', newImageSrc);
    $('.shade-display').html(variantTitle);
  }
});

 /*PDP super script issue*/
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.metafield-rich_text_field p').forEach(el => {
      el.innerHTML = el.innerHTML
        .replace(/®/g, '<sup>®</sup>')
        .replace(/™/g, '<sup>™</sup>');
    });
  });

$(document).ready(function () {
  const interval = setInterval(function () {
  const labelText = $('.pdp-add-to-cart .add_to_cart_label').text().trim();        
    if (labelText === 'Subscribe') {     
      const subscriptionValue = $('input[name="subscription_terms"]').val();
      $('input[name="properties[_subscription_terms]"]').val(subscriptionValue);
     clearInterval(interval);
    }
   
  }, 300);  
});

function updatePriceInFooter() { 
    var priceElement = $('.rc-radio--active.subscription-radio .rc-radio__price'); 
    if (priceElement.length > 0) { 
        var priceHtml = priceElement.html(); 
        $('.sticky-footer-price').html(priceHtml);
        clearInterval(checkPrice); 
    }
}

// Try every 300ms until it appears (max 5s)
var checkPrice = setInterval(updatePriceInFooter, 3000);
setTimeout(() => clearInterval(checkPrice), 5000); // safety timeout

